import React from 'react';

import FileManagerHeader from './components/FileManagerHeader/FileManagerHeader';
import FileManagerView from './components/FileManagerView/FileManagerView';

function FileManagerContainer() {
  return (
    <div className="px-lg-2 r-px-0 pb-3">
      <FileManagerHeader />
      <FileManagerView />
    </div>
  );
}

export default FileManagerContainer;
